module.exports = "/_next/static/resources/array-dc57f4196ef13ab644a029e76a3bf28b.webp";